import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { MicrosoftTeamsAudioConferencing } from '../../../shared/models/generated/ziroModels';

@Injectable()
export class MicrosoftTeamsAudioConferencingResource {
  private http = inject(HttpClient);

  put(tenantId: number, upn: string, request: MicrosoftTeamsAudioConferencing): Observable<void> {
    return this.http.put<void>(`/services/microsoft/macs/tenants/${tenantId}/teams-audio-conferences/${upn}`, request);
  }
}
